import { offer } from '@src/api/actions';
import { getSafe } from '@src/tools/util';
export const getChannelList = (q) => offer.getOfferRequestChannelList(q).then((d) => getSafe(d, 'data', []));
export const setChannel = (data) => offer.setOfferRequestChannel(data);
